import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store";
import * as Sentry from "@sentry/react";
import { onStatusChange } from "./utils/syncQueue";

Sentry.init({
  dsn: "https://29f8e77e1cb58c44cbe084b1122fb157@o4509950729060352.ingest.de.sentry.io/4509950730698832",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
});

// Telemetry for the syncQueue: convert every flush transition into a
// Sentry breadcrumb so we can distinguish "save errored" (network /
// dyno / 5xx) from "save returned 200 but rejected fields" (clock
// drift / fieldMeta race) when triaging reports.
onStatusChange((event) => {
  Sentry.addBreadcrumb({
    category: "sync",
    type: event.status === "error" ? "error" : "info",
    level: event.status === "error" ? "warning" : "info",
    message: `syncQueue ${event.status}`,
    data: {
      recordType: event.recordType,
      recordId: event.recordId,
      acceptedFields: event.acceptedFields,
      rejectedFields: event.rejectedFields,
      error: event.error?.message,
    },
  });
  if (event.status === "error") {
    Sentry.captureMessage(
      `syncQueue flush failed (${event.recordType})`,
      "warning",
    );
  } else if (event.rejectedFields && event.rejectedFields.length > 0) {
    Sentry.captureMessage(
      `syncQueue rejected fields (${event.recordType}): ${event.rejectedFields.join(",")}`,
      "info",
    );
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>
);
